import { Color, createTheme } from '@mui/material';

// This theme file should be broken out into additional files once we have more complexity

const blue: Color = {
  50: '#131C7A',
  100: '#131C7A',
  200: '#131C7A',
  300: '#131C7A',
  400: '#131C7A',
  500: '#131C7A',
  600: '#131C7A',
  700: '#131C7A',
  800: '#131C7A',
  900: '#131C7A',
  A100: '#131C7A',
  A200: '#131C7A',
  A400: '#131C7A',
  A700: '#131C7A',
};

export const registrationTheme = createTheme({
  palette: {
    primary: {
      main: blue['700'],
    },
  },
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        asterisk: {
          color: '#db3131',
        },
      },
    },
  },
});

export const brokerSharingTheme = createTheme({
  palette: {
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#0037FF',
    },
  },
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        asterisk: {
          color: '#db3131',
        },
      },
    },
  },
});
